// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import 'react-quill/dist/quill.snow.css';
// import './RichEditorComponent.css';
// import { useTranslation } from '../redux/TranslationHelper';

// const RichEditorComponent = ({ id, componentProps = {}, style = {} }) => {
//   const { t } = useTranslation();
//   const component = useSelector(state => 
//     state.editor.components.find(comp => comp.id === id)
//   );
//   const [content, setContent] = useState('');
//   const isPreview = componentProps.isPreview === true;

//   useEffect(() => {
//     // Redux에서 컴포넌트를 찾은 경우 (에디터 모드)
//     if (component && component.content) {
//       setContent(component.content);
//     } 
//     // componentProps에서 직접 content를 받은 경우 (프리뷰 모드)
//     else if (componentProps && componentProps.content) {
//       setContent(componentProps.content);
//     }
//   }, [component, componentProps]);

//   const combinedStyle = {
//     ...style,
//     ...(componentProps.style || {})
//   };

//   // HTML 내용이 유효한지 확인하는 함수
//   // const isValidHTML = (html) => {
//   //   if (!html || typeof html !== 'string') return false;
    
//   //   try {
//   //     // HTML 문자열로부터 임시 DOM 생성
//   //     const parser = new DOMParser();
//   //     const doc = parser.parseFromString(html, 'text/html');
      
//   //     // parseError 확인
//   //     const parseError = doc.querySelector('parsererror');
//   //     if (parseError) {
//   //       console.error(t('HTML 파싱 오류:'), parseError.textContent);
//   //       return false;
//   //     }
      
//   //     return true;
//   //   } catch (error) {
//   //     console.error(t('HTML 유효성 검사 오류:'), error);
//   //     return false;
//   //   }
//   // };


//   // HTML 내용이 유효한지 확인하는 함수
// const isValidHTML = (html) => {
//   if (!html) return false;
  
//   // 객체인 경우 deviceProperty를 확인하거나 html 속성 확인
//   if (typeof html === 'object' && html !== null) {
//     if (html.deviceProperty && devicePropertyTab && html.deviceProperty[devicePropertyTab]) {
//       return typeof html.deviceProperty[devicePropertyTab] === 'string' && html.deviceProperty[devicePropertyTab].length > 0;
//     } else if (html.html) {
//       return typeof html.html === 'string' && html.html.length > 0;
//     }
//     return false;
//   }
  
//   // 문자열인 경우 직접 확인
//   if (typeof html === 'string') {
//     try {
//       // 간단한 검사
//       return html.trim().length > 0;
//     } catch (error) {
//       console.error(t('HTML 유효성 검사 오류:'), error);
//       return false;
//     }
//   }
  
//   return false;
// };



//   // 컴포넌트 클래스 이름 설정
//   const componentClassName = `rich-editor-component ${isPreview ? 'preview-mode' : ''}`.trim();

//   // 실제 에디터는 PropertyPanel에서 처리되고, 여기서는 결과물만 표시
//   // return (
//   //   <div className={componentClassName} style={combinedStyle}>
//   //     {isValidHTML(content) ? (
//   //       <div 
//   //         className="rich-editor-display"
//   //         dangerouslySetInnerHTML={{ __html: content }}
//   //       />
//   //     ) : (
//   //       <div className="rich-editor-error">
//   //         {content ? t('유효하지 않은 HTML 내용입니다. HTML 코드를 확인해주세요.') : t('내용을 입력해주세요.')}
//   //       </div>
//   //     )}
//   //   </div>
//   // );


//   return (
//     <div className={componentClassName} style={combinedStyle}>
//       {isValidHTML(content) ? (
//         <div 
//           className="rich-editor-display"
//           dangerouslySetInnerHTML={{ 
//             __html: typeof content === 'string' 
//               ? content 
//               : (content.deviceProperty && devicePropertyTab && content.deviceProperty[devicePropertyTab]) 
//                 ? content.deviceProperty[devicePropertyTab] 
//                 : (content.html || '')
//           }}
//         />
//       ) : (
//         <div className="rich-editor-error">
//           {content ? t('유효하지 않은 HTML 내용입니다. HTML 코드를 확인해주세요.') : t('내용을 입력해주세요.')}
//         </div>
//       )}
//     </div>
//   );
// };

// export default RichEditorComponent; 


import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import 'react-quill/dist/quill.snow.css';
import './RichEditorComponent.css';
import { useTranslation } from '../redux/TranslationHelper';

const RichEditorComponent = ({ id, componentProps = {}, style = {} }) => {
  const { t } = useTranslation();
  const component = useSelector(state => 
    state.editor.components.find(comp => comp.id === id)
  );
  const [content, setContent] = useState('');
  const isPreview = componentProps.isPreview === true;

  useEffect(() => {
    // Redux에서 컴포넌트를 찾은 경우 (에디터 모드)
    if (component && component.content) {
      setContent(component.content);
    } 
    // componentProps에서 직접 content를 받은 경우 (프리뷰 모드)
    else if (componentProps && componentProps.content) {
      setContent(componentProps.content);
    }
  }, [component, componentProps]);

  const combinedStyle = {
    ...style,
    ...(componentProps.style || {})
  };

  // HTML 내용이 유효한지 확인하는 함수
  const isValidHTML = (html) => {
    if (!html) return false;
    
    // 객체인 경우 html 속성 확인
    if (typeof html === 'object' && html !== null) {
      if (html.html) {
        return typeof html.html === 'string' && html.html.length > 0;
      }
      return false;
    }
    
    // 문자열인 경우 직접 확인
    if (typeof html === 'string') {
      try {
        // 간단한 검사
        return html.trim().length > 0;
      } catch (error) {
        console.error(t('HTML 유효성 검사 오류:'), error);
        return false;
      }
    }
    
    return false;
  };

  // HTML 콘텐츠 추출 함수
  const extractHtmlContent = (content) => {
    if (typeof content === 'string') {
      return content;
    } 
    
    if (typeof content === 'object' && content !== null) {
      // deviceProperty 구조가 있는 경우는 렌더링하지 않음 (이미지-텍스트 컴포넌트에서 처리)
      if (content.html) {
        return content.html;
      }
    }
    
    return '';
  };

  // 컴포넌트 클래스 이름 설정
  const componentClassName = `rich-editor-component ${isPreview ? 'preview-mode' : ''}`.trim();

  // 실제 에디터는 PropertyPanel에서 처리되고, 여기서는 결과물만 표시
  return (
    <div className={componentClassName} style={combinedStyle}>
      {isValidHTML(content) ? (
        <div 
          className="rich-editor-display"
          dangerouslySetInnerHTML={{ __html: extractHtmlContent(content) }}
        />
      ) : (
        <div className="rich-editor-error">
          {content ? t('유효하지 않은 HTML 내용입니다. HTML 코드를 확인해주세요.') : t('내용을 입력해주세요.')}
        </div>
      )}
    </div>
  );
};

export default RichEditorComponent;